import TimeframeDropdownFilter from './TimeframeDropdownFilter.component';

export default TimeframeDropdownFilter;
